import translate from '@translate';
import { TabType } from 'src/components/Tabs';
import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'SKU',
        label: 'SKU',
        defaultShow: true,
    },
    {
        key: 'NAME',
        label: 'name',
        defaultShow: true,
        customRender: true,
    },
    {
        key: 'EAN',
        label: 'EAN',
        customRender: true,
        defaultShow: true,
    },
    {
        key: 'EAN_LOCKED_BY_DCIX',
        label: 'eanLockedByWms',
        type: 'select',
        selectOption: 'boolNumberCodes',
        defaultShow: false,
    },
    {
        key: 'HS_CODE',
        label: 'hsCode',
    },
    {
        key: 'BATTERY_TYPE',
        label: 'batteryType',
        type: 'select',
        selectOption: 'batteryTypeCodes',
    },
    {
        key: 'PRODUCT_TYPE',
        label: 'productType',
        type: 'select',
        selectOption: 'productTypeCodes',
    },
    {
        key: 'EXP_METHOD',
        label: 'expeditionMethod',
        type: 'select',
        selectOption: 'expeditionMethodCodes',
    },
    {
        key: 'INSERT_TYPE',
        label: 'insertType',
        type: 'select',
        selectOption: 'productInsetTypeCodes',
    },
    {
        key: 'INSERT_BY_ORDER_TYPE',
        label: 'insertByOrderType',
        type: 'select',
        selectOption: 'insertByOrderTypeCodes',
        defaultShow: false,
    },
    {
        key: 'DESCRIPTION',
        label: 'description',
    },
    {
        key: 'ROP',
        label: 'ROP',
        type: 'number-filter'
    },
    {
        key: 'EXPIRATION_DAYS',
        label: 'EXPIRATION_DAYS',
        type: 'number-filter'
    },
    {
        key: 'AGECHECK',
        label: 'agecheck',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'GLOBAL_PRODUCT',
        label: 'globalProduct',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'QUANTITY_CONVERSION',
        label: 'quantityConversion',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'SCAN_IMEI_SN_TYPE',
        label: 'scanSerialNumber',
        type: 'select',
        selectOption: 'scanImeiSnCodes',
    },
    {
        key: 'SN_REGEX',
        label: 'snRegex',
    },
    {
        key: 'WEIGHT',
        label: 'weight',
        type: 'number-filter'
    },
    {
        key: 'WIDTH',
        label: 'width',
        type: 'number-filter'
    },
    {
        key: 'HEIGHT',
        label: 'height',
        type: 'number-filter'
    },
    {
        key: 'LENGTH',
        label: 'length',
        type: 'number-filter'
    },
    {
        key: 'PRICE',
        label: 'price',
        type: 'number-filter'
    },
    {
        key: 'UNIT_PRICE',
        label: 'unitPrice',
        type: 'select',
        selectOption: 'currencyCodes',
    },
    {
        key: 'CUSTOM_FIELD_1',
        label: 'customField1',
    },
    {
        key: 'CUSTOM_FIELD_2',
        label: 'customField2',
    },
    {
        key: 'CUSTOM_FIELD_3',
        label: 'customField3',
    },
    {
        label: 'lot',
        key: 'lot',
        defaultShow: true,
    },
    {
        label: 'expirationDate',
        key: 'expirationDate',
        type: 'date',
        defaultShow: true,
    },
    {
        key: 'ALLOCATED_QUANTITY',
        label: 'allocated',
        type: 'number-filter',
        defaultShow: true,
        allwaysShow: true,
        tooltip: 'products.table.allocated.tooltip'
    },
    {
        key: 'HOLD_QUANTITY',
        label: 'onExpedition',
        type: 'number-filter',
        defaultShow: true,
        allwaysShow: true
    },
    {
        key: 'AVAILABLE_QUANTITY',
        label: 'available',
        type: 'number-filter',
        defaultShow: true,
        customRender: true,
        allwaysShow: true,
        tooltip: 'products.table.available.tooltip'
    },
    {
        key: 'QUALITY_HOLD_QUANTITY',
        label: 'onHoldQuality',
        type: 'number-filter',
        defaultShow: true,
        allwaysShow: true
    },
    {
        key: 'QUANTITY',
        label: 'all',
        type: 'number-filter',
        defaultShow: true,
        allwaysShow: true,
        tooltip: 'products.table.all.tooltip'
    },
    {
        key: 'EXPECTED_QUANTITY',
        label: 'awaiting',
        type: 'number-filter',
        defaultShow: true,
        allwaysShow: true
    },
    {
        key: 'DUTY_QUANTITY',
        label: 'customsWarehouse',
        type: 'number-filter',
        defaultShow: true,
        allwaysShow: true
    },
    {
        key: 'ORIGIN_COUNTRY',
        label: 'originCountry',
        type: 'select',
        selectOption: 'countryOptionsCodes',
    },
    {
        key: 'ACTIVE',
        label: 'active',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'CREATED_AT',
        label: 'createdAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'UPDATED_AT',
        label: 'updatedAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'DIMENSIONS_CHANGED_AT',
        label: 'dimensionsChangedAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'DELETED_AT',
        label: 'deletedAt',
        type: 'dateTime',
        defaultShow: false,
    },
    {
        key: 'IS_DELETED',
        label: 'isDeleted',
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'SOURCE_SYS',
        label: 'sourceSys',
        type: 'select',
        selectOption: 'productSourceSysCodes',
        defaultShow: false,
    },
];

export const getAllColumns = (allStockBoolean: boolean): TableColumnType[] => {
    return allColumns.map(column => {
        if (column.key === 'lot' || column.key === 'expirationDate') {
            return { ...column, allwaysShow: allStockBoolean };
        }
        return column;
    });
};

export const TABS: TabType[] = [
    { value: 'all', label: translate('products.all') },
    { value: 'active', label: translate('products.active') },
    { value: 'inactive', label: translate('products.inactive') },
    { value: 'deleted', label: translate('products.deleted') },
    { value: 'sets', label: translate('products.sets') },
    { value: 'packgingMaterials', label: translate('products.packgingMaterials') },
    { value: 'promoMaterials', label: translate('products.promoMaterials') },
    { value: 'bill_of_materials', label: translate('products.billOfMaterials') },
];
